import { render, staticRenderFns } from "./SidePreview.vue?vue&type=template&id=63e6ff1e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidePreview.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/SidePreview.vue
// module id = 2439
// module chunks = 1